import { removeZipCodeFromAddress } from 'shared/lib/addressFields';
import type { TDataCity } from 'shared/types/TUserAddressFields';

export const makeRegionFieldValue = (
  data?: {
    unrestricted_value: string;
    fias_id: string;
  } | null,
): Nullable<Dictionaries.TSelectValue<string, TDataCity>> => {
  if (!data) {
    return null;
  }

  const addressName = removeZipCodeFromAddress(data.unrestricted_value);
  return {
    value: addressName,
    label: addressName,
    data: {
      city_fias_id: data.fias_id,
      unrestricted_value: addressName,
    } as TDataCity,
  };
};
